// NPM packages
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

// Web assets
import logo from '../images/logo.png';
import BG from '../images/devices-pattern.jpg';

// Internal React components
import EmailInput from '../components/EmailInput';
import SendText from '../components/SendText';
import PartyText from '../components/PartyText';
import ErrorText from '../components/ErrorText';
import SpinnerText from '../components/SpinnerText';

// Styled components

const Left = styled.div`
  background: #fafbfd;
  padding: 6vh 4vw;

  /* 1D Vertical Layout */
  display: flex;
  flex-direction: column;
`;

const Right = styled.div`
  background-color: #262229;
  background-image: url(${BG});
  background-size: cover;
  background-repeat: no-repeat;

  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const Logo = styled.img`
  max-width: 50%;
  width: 200px;
  align-self: flex-start;
  margin: 0;
`;

const PitchCopy = styled.div`
  flex: 5;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2em 0;

  p {
    line-height: 1.9;
  }

  @media only screen and (max-width: 480px) {
    font-size: 85%;

    h1 {
      font-size: 1.75rem;
    }
  }
`;

const Footer = styled.div`
  display: flex;
  align-items: flex-end;

  @media only screen and (max-width: 480px) {
    font-size: 75%;
  }
`;

const Container = styled.main`
  padding: 0;
  margin: 0;
  max-width: 100%;
  max-height: 100%;
  height: 100vh;
  width: 100vw;
  position: relative;

  /* CSS Grid settings */
  display: grid;
  grid-template-columns: 2fr 3fr;

  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

// API endpoints
const BACKBONE_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? 'https://us-central1-meledia-backbone.cloudfunctions.net/sendMail'
    : 'http://localhost:8010/meledia-backbone-dev/us-central1/sendMail';

export default class Index extends Component {
  constructor(props) {
    super(props);

    // Default state
    this.state = {
      email: '', // user email
      btnText: <SendText />, // updates when mail is sent,
      noBots: false,
    };
  }

  componentDidMount() {
    if (process.env.GATSBY_CONTEXT !== 'production') {
      this.setState({ noBots: true });
    }
  }

  async sendMail() {
    console.log('Sending email... 📬');
    try {
      // Update state to indicate action
      this.setState({
        btnText: <SpinnerText />,
      });

      const fetchHeaders = new Headers();
      fetchHeaders.append('Content-Type', 'application/json');

      // Send customer email and wait for a response from API
      const emailResponseBlob = await fetch(BACKBONE_ENDPOINT, {
        method: 'POST',
        headers: fetchHeaders,
        body: JSON.stringify({
          email: this.state.email,
        }),
      });

      // Throw error to exit function if response isn't OK
      if (!emailResponseBlob.ok) {
        throw new Error(emailResponseBlob.statusText);
      }

      // Update the button with a notification of success! Turn off progress
      // indicator
      this.setState({
        btnText: <PartyText />,
      });
      console.log('Mail sent! 📨');
      console.log(emailResponseBlob);

      return true;
    } catch (mailErr) {
      // First turn off progress indicator
      this.setState({
        sendingMail: false,
        btnText: <ErrorText />,
      });
      // Log the error and move on
      console.error(mailErr);
      return false;
    }
  }

  updateEmailInput(event) {
    this.setState({
      email: event.target.value,
    });
  }

  render() {
    return (
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Meledia — Handcrafted Branding & Web Design — Pittsburgh, PA
          </title>
          <meta
            name="description"
            content="Meledia is your one stop shop for forging a powerful digital identity. We'll work with you to define your brand and show the world what you're all about!"
          />
          <meta name="theme-color" content="#91C9C4" />
          {this.state.noBots && <meta name="robots" content="noindex" />}
          <link rel="icon" type="image/x-icon" href="/favicons/favicon.ico" />
          <link
            rel="icon"
            type="image/png"
            href="/favicons/favicon-32x32.png"
          />
          <link rel="manifest" href="/favicons/manifest.json" />
        </Helmet>
        <Left>
          <Logo src={logo} />
          <PitchCopy>
            <h1>Give Your Ideas an Audience</h1>
            <p>
              You've already worked out the hardest part of defining a brand —
              thinking it up! Let Meledia help you unveil your ideas to the
              world with modern web design, expert brand consultation, and
              unparalleled, customized service.
            </p>
            <p>
              Whether you're an established enterprise or a growing startup,
              we'll work with you directly and tirelessly to elevate your
              business.
            </p>
            <p>
              Drop your email below to learn more about us and hear directly
              from one of our designers. (That's right, a real person!) And we{' '}
              <i>promise</i>, no spam!
            </p>
            <EmailInput
              placeholder="Your email"
              btnText={this.state.btnText}
              clickHandler={() => this.sendMail()}
              inputUpdateHandler={event => this.updateEmailInput(event)}
            />
          </PitchCopy>
          <Footer>
            <small>©2017, Meledia LLC.</small>
          </Footer>
        </Left>
        <Right />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js